const OldSystemFrame = () => import('@/views/OldSystemFrame');

export default [
  {
    path: 'funlearn',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: 'overview',
        component: OldSystemFrame,
        props:{
          url: '/login/templates/content.php?id=424'
        }
      },
      {
        path: 'settings',
        component: OldSystemFrame,
        props:{
          url: '/login/templates/content.php?id=425&func=showFunlearnSettings'
        }
      },
    ]
  },
]
